import React     from 'react';
import PropTypes from 'prop-types';
import TopFilter from '../Filter/TopFilter.js';
import Tag       from './Tag.js';

class TopFilterContainer extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {};

        this.topFilterBarRef = null;

        this.onClickToggleFilter = this.onClickToggleFilter.bind(this);
    }

    onClickToggleFilter() {
        /* const wrapperTop = this.topFilterBarRef.topFilterWrapperRef.getBoundingClientRect().top;
         const wrapperHeight = this.topFilterBarRef.topFilterWrapperRef.getBoundingClientRect().height;
         if (!this.props.isMobile && !this.props.showFilter && window.scrollY > (wrapperTop + window.scrollY)) {
             window.scrollTo({
                 top: wrapperTop - wrapperHeight - 20 + window.scrollY,
                 behavior: 'smooth'
             });
         }*/
        this.props.onClickToggleFilter();
    }

    getFilterButton() {
        return <button className='filter__top-tags__icon__wrapper' onClick={() => this.onClickToggleFilter()}>
            <i className={'icon -icon-filter-regulator filter__top-tags__icon' + (this.props.activeFilterCount > 0 ? ' filter__top-tags__icon--count' : '') + (this.props.showFilter ? " filter__top-tags__icon--active" : '')}></i>
            {this.props.activeFilterCount > 0 && <div className='filter__top-tags__icon__badge'>{this.props.activeFilterCount}</div>}
        </button>;
    }

    render() {
        const tagsList = <div className='filter__top-tags__list'>
            { this.props.tags.map((tag, idx) => <Tag tag={tag} onClickTag={this.props.onClickTag} key={idx} />) }
        </div>;

        const commonProps = {
            tagsList,
            isMobile:           this.props.isMobile,
            compRef:        this.props.compRef,
            topFilterCompRef: this,
        };

        return [
            <TopFilter key='top-filter-0' {...commonProps} isSticky={false} filterButton={this.getFilterButton(false)} ref={ref => this.topFilterBarRef = ref} />,
            <TopFilter key='top-filter-1' {...commonProps} isSticky={true} filterButton={this.getFilterButton(true)} />
        ];
    }
}

TopFilterContainer.propTypes = {
    tags:                PropTypes.array,
    onClickTag:          PropTypes.func.isRequired,
    isMobile:            PropTypes.bool,
    activeFilterCount:   PropTypes.number,
    onClickToggleFilter: PropTypes.func,
    showFilter:          PropTypes.bool,
    compRef:         PropTypes.object,

};

export default TopFilterContainer;
